import { Alert, Badge } from "react-bootstrap";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";
import { format, parseISO } from "date-fns";
import DescriptionIcon from "@mui/icons-material/Description";
import BadgeEstados from "../../../../components/BadgeEstado";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import FileIcon from "../../../../components/svgs/FileIcon";
import FileAvisoIcon from "../../../../components/svgs/FileAvisoIcon";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { toastOptions } from "../../../../config/toast";
import useActas from "../../../../api/actas";
import Opcion from "../../ModalActaDetalle/OpcionesActaDetalle2/Opcion";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../../../context";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReciboIcon from "../../../../components/svgs/ReciboIcon";
import AvisoIcon from "../../../../components/svgs/AvisoIcon";
import AdjustIcon from "@mui/icons-material/Adjust";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MotivoIcon from "../../../../components/svgs/MotivoIcon";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import AnularIcon from "../../../../components/svgs/AnularIcon";
import DescargoIcon from "../../../../components/svgs/DescargoIcon";
import HistoryFileIcon from "../../../../components/svgs/HistoryFileIcon";
import JudgeIcon from "../../../../components/svgs/JudgeIcon";
import PagoIcon from "../../../../components/svgs/PagoIcon";

const InfoActa2 = ({ opciones }) => {
  const { handlerModal, modals } = useGeneralAppStore();
  const { actaDetalle, alertas, alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();
  const { acta, archivos, recibo } = actaDetalle;
  const { getActaChequear, getActaDetalle } = useActas();
  const { actions } = useContext(UserContext);
  const location = useLocation();

  const copiarPortaPapeles = (texto) => {
    navigator.clipboard
      .writeText(texto)
      .then(() => {
        toast.success("Copiado al portapeles", toastOptions);
      })
      .catch((err) => {
        toast.success(err, toastOptions);
      });
  };

  const emailsCortesia = acta?.emails_cortesia?.filter((email) => email.estado_id == 3).sort((a, b) => new Date(b.fecha_enviado) - new Date(a.fecha_enviado)) || null;

  return (
    <div className=" row">
      <section className="col">
        {/* //^ INFO DEL ACTA*/}
        <div className="">
          {/* <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1" style={{ borderBottom: "1px solid gray", width: "fit-content" }}>Información del acta</h6> */}
          <p className="m-0 text-primary fw-bold mb-2">
            <DescriptionIcon />
            Acta {acta?.dependencia} - {acta?.numero_infraccion}
          </p>
          <div className="d-flex flex-column gap-2">
            <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
              Estado: <BadgeEstados estado_id={acta?.estado_id} />
            </p>
            <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
              Fecha y hora:{" "}
              <span style={{ fontSize: "14px" }} className=" fw-bold ">
                {acta?.fecha_hora ? format(parseISO(acta?.fecha_hora), "dd/MM/yy HH:mm") : "No tiene"}
              </span>
            </p>
            <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
              Tipo infracción:{" "}
              <span style={{ fontSize: "14px" }} className=" fw-bold ">
                {acta.tipo}
              </span>
            </p>
            <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
              Dirección:{" "}
              <span style={{ fontSize: "14px" }} className=" fw-bold ">
                {acta.direccion}
              </span>
            </p>
            {acta?.estado_id != 3 && (
              <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
                Tipo Acta:{" "}
                <Badge style={{ verticalAlign: "middle" }} bg={acta?.tipo_acta_generada == "DIGITAL" ? "success" : "primary"}>
                  {acta?.tipo_acta_generada}
                </Badge>
              </p>
            )}
            {acta?.fecha_emision_fisica && (
              <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
                Fecha emisión:{" "}
                <span className=" fw-bold " style={{ fontSize: "14px" }}>
                  {format(parseISO(acta?.fecha_emision_fisica), "dd/MM/yy HH:mm")}
                </span>{" "}
              </p>
            )}
            {acta?.fecha_emision_digital && (
              <p className="  fw-medium m-0" style={{ fontSize: "12px" }}>
                Fecha emisión:{" "}
                <span className=" fw-bold " style={{ fontSize: "14px" }}>
                  {format(parseISO(acta?.fecha_emision_digital), "dd/MM/yy HH:mm")}
                </span>{" "}
              </p>
            )}
            {acta?.fecha_impresion && (
              // ((acta?.estado_id == 2) || (acta?.estado_id == 8) || (acta?.estado_id == 4 && acta?.tipo_acta_generada == 'FISICA')) &&
              <p className=" fw-medium m-0" style={{ fontSize: "12px" }}>
                Fecha impresion:{" "}
                <span className=" fw-bold " style={{ fontSize: "14px" }}>
                  {format(parseISO(acta?.fecha_impresion), "dd/MM/yy HH:mm")}
                </span>
              </p>
            )}
            {acta?.fecha_notificacion && (
              <p className=" fw-medium m-0" style={{ fontSize: "12px" }}>
                Fecha notificación:{" "}
                <span className=" fw-bold " style={{ fontSize: "14px" }}>
                  {format(parseISO(acta?.fecha_notificacion), "dd/MM/yy HH:mm")}
                </span>
              </p>
            )}
            {emailsCortesia?.length > 0 && (
              <p className=" fw-medium m-0" style={{ fontSize: "12px" }}>
                Fecha email cortesia:{" "}
                <span className=" fw-bold " style={{ fontSize: "14px" }}>
                  {format(parseISO(emailsCortesia[0].fecha_enviado), "dd/MM/yy HH:mm")}
                </span>
              </p>
            )}

            {![3, 7].includes(acta?.estado_id) && (
              <>
                <p className="fw-bold text-primary m-0 mt-3">
                  <AdjustIcon /> Acciones
                </p>
                <div className="d-flex gap-4 flex-wrap">
                  {archivos?.actas?.length > 0 && (
                    <Tooltip title="Ver acta PDF" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-primary-subtle rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "ver_acta" });
                          }}
                        >
                          <FileIcon color="#1134C9" />
                        </div>
                        <p className="m-0 fw-semibold text-primary d-flex justify-content-center text-center" style={{ fontSize: "12px", width: "50px" }}>
                          Acta
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {archivos?.aviso && acta?.estado_id != 10 && (
                    <Tooltip title="Ver aviso de visita" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-warning-subtle rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "ver_aviso" });
                          }}
                        >
                          <AvisoIcon color="#FFC107" />
                        </div>
                        <p className="m-0 fw-semibold  d-flex justify-content-center text-center" style={{ fontSize: "12px", width: "50px" }}>
                          Aviso
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {acta?.motivo_no_notificado?.length > 0 && (
                    <Tooltip title="Ver motivo de no notificacion" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-danger-subtle rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "ver_motivo" });
                          }}
                        >
                          <MotivoIcon color="#dc3545" />
                        </div>
                        <p className="m-0 fw-semibold  d-flex justify-content-center text-center text-danger" style={{ fontSize: "12px", width: "50px" }}>
                          Motivo
                        </p>
                      </div>
                    </Tooltip>
                  )}

                  {acta.fecha_notificacion && acta.tipo_acta_generada == "DIGITAL" && (
                    <Tooltip title="Constancia de notificación" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-primary-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "constancia" });
                          }}
                        >
                          <FileAvisoIcon color="#1134C9" />
                        </div>
                        <p className="m-0 fw-semibold text-primary d-flex justify-content-center text-center" style={{ fontSize: "12px", width: "50px" }}>
                          Constancia
                        </p>
                      </div>
                    </Tooltip>
                  )}

                  {acta?.estado_id == 12 && (
                    <Tooltip title="Constancia de anulación" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-danger-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "constancia_anulacion" });
                          }}
                        >
                          <FileAvisoIcon color="#dc3545" />
                        </div>
                        <p className="m-0 fw-semibold text-danger d-flex justify-content-center text-center" style={{ fontSize: "12px", width: "50px" }}>
                          Constancia anulacion
                        </p>
                      </div>
                    </Tooltip>
                  )}

                  {
                    // location.pathname == "/buscar-acta" &&

                    (actions.hasPermission("recibo.view.general") || actions.hasPermission("JP") || actions.hasRole("admin") || actions.hasRole("147") || actions.hasRole("admin.app")) &&
                      acta?.estado_id != 12 &&
                      acta.estado_id != 13 &&
                      acta.estado_id != 15 && (
                        <Tooltip title="Consultar recibo" arrow>
                          <div className="d-flex flex-column align-items-center">
                            <div
                              className="bg-success-subtle  rounded-circle d-flex justify-content-center align-items-center "
                              style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                              onClick={() => {
                                handlerModal({ modal: true, modalName: "modal_recibo" });
                              }}
                            >
                              <ReciboIcon color="#198754" />
                            </div>
                            <p className="m-0 fw-semibold text-success d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                              Recibo
                            </p>
                          </div>
                        </Tooltip>
                      )
                  }
                  {(actions.hasPermission("JP") || actions.hasRole("admin.app") || actions.hasRole("admin")) && ![11, 4, 12].includes(acta?.estado_id) && (
                    <Tooltip title="Anular acta" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-danger-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_confirm" });
                          }}
                        >
                          <AnularIcon color="#dc3545" />
                        </div>
                        <p className="m-0 fw-semibold text-danger d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Anular
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {actions.hasPermission("JP") && acta?.estado_id == 4 && (
                    <Tooltip title="Anular acta notificada" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-danger-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_confirm" });
                          }}
                        >
                          <AnularIcon color="#dc3545" />
                        </div>
                        <p className="m-0 fw-semibold text-danger d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Anular Notificada
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {(actions.hasPermission("JP") || actions.hasRole("tribunales") || actions.hasRole("admin")) && ![11, 13, 12, 15, 19].includes(acta?.estado_id) && (
                    <Tooltip title="Acta a Descargo" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-dark-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "descargo" });
                          }}
                        >
                          <DescargoIcon color="#111" />
                        </div>
                        <p className="m-0 fw-semibold text-dark d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Descargo
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {(actions.hasPermission("JP") || actions.hasRole("admin.app")) && [10].includes(acta?.estado_id) && (
                    <Tooltip title="Cambiar incompleta" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-danger-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "incompleta_acta_detalle" });
                          }}
                        >
                          <DescargoIcon color="#dc3545" />
                        </div>
                        <p className="m-0 fw-semibold text-danger d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Incompleta
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {/* {
                                        ((actions.hasPermission("JP") || actions.hasRole("admin.app") || actions.hasRole("admin")) && ![3].includes(acta?.estado_id)) &&
                                        <Tooltip title="Auditoria del acta" arrow>
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="bg-dark-subtle  rounded-circle d-flex justify-content-center align-items-center " style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                                                    onClick={() => { handlerModal({ modal: true, modalName: "auditar_acta" }) }}>
                                                    <HistoryFileIcon color="#111" />
                                                </div>
                                                <p className="m-0 fw-semibold text-dark d-flex justify-content-center text-center"
                                                    style={{ fontSize: "12px", maxWidth: "50px" }}
                                                >Auditar</p>
                                            </div>
                                        </Tooltip>
                                    } */}
                  {/* NADIE PUEDE MARCAR ACTA COMO NOTIFICADA FISCA */}
                  {/* {actions.hasRole("tribunales") && [10, 8, 9, 2].includes(acta.estado_id) && (
                    <Tooltip title="Notificar acta" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-success-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_notificar_acta" });
                          }}
                        >
                          <HistoryFileIcon color="#198754" />
                        </div>
                        <p
                          className="m-0 fw-semibold text-success d-flex justify-content-center text-center"
                          style={{ fontSize: "12px", maxWidth: "50px" }}
                        >
                          Notificar
                        </p>
                      </div>
                    </Tooltip>
                  )} */}
                  {actions.hasRole("tribunales") && [15, 13].includes(acta.estado_id) && (
                    // <Tooltip title="Dictaminar acta" arrow>
                    <Tooltip title="Resolución" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="  rounded-circle d-flex justify-content-center align-items-center "
                          style={{
                            width: "fit-content",
                            padding: "0.7rem",
                            cursor: "pointer",
                            background: "#FFCDFF",
                          }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_dictaminar_acta" });
                          }}
                        >
                          <JudgeIcon color="#7B1FA2" />
                        </div>
                        <p className="m-0 fw-semibold d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px", color: "#7B1FA2" }}>
                          {/* Dictaminar */}
                          Resolución
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {actions.hasRole("tribunales") && actions.hasPermission("dictamen.pagovoluntario.create") && acta.estado_id == 19 && (
                    <Tooltip title="Generar pago" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="rounded-circle d-flex justify-content-center align-items-center "
                          style={{
                            width: "fit-content",
                            padding: "0.7rem",
                            cursor: "pointer",
                            background: acta?.dictamenes?.length > 0 ? (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior ? "#c9c9c9" : "#FFCDFF") : "#FFCDFF",
                          }}
                          onClick={() => {
                            if (acta?.dictamenes?.length > 0) {
                              if (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior) {
                                <></>;
                              } else {
                                handlerModal({ modal: true, modalName: "modal_generar_pago" });
                              }
                            } else {
                              handlerModal({ modal: true, modalName: "modal_generar_pago" });
                            }
                            // (acta?.dictamenes?.length > 0) ? ((acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior) ? "#c9c9c9" : "#c9c9c9") : "#FFCDFF"
                            // handlerModal({ modal: true, modalName: "modal_generar_pago" })
                          }}
                        >
                          <JudgeIcon color={acta?.dictamenes?.length > 0 ? (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior ? "#777" : `#7B1FA2`) : `#7B1FA2`} />
                        </div>
                        <p
                          className="m-0 fw-semibold d-flex justify-content-center text-center"
                          style={{
                            fontSize: "12px",
                            maxWidth: "50px",
                            color: acta?.dictamenes?.length > 0 ? (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior ? "#777" : `#7B1FA2`) : `#7B1FA2`,
                          }}
                        >
                          Generar pago
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {actions.hasRole("tribunales") /* && acta.estado_id == 19 */ && actions.hasPermission("dictamen.marcar_pago_acta.create") && (
                    <>
                      {
                        /* ((acta?.dictamenes?.length > 0) && (acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante)) && */
                        // <Tooltip title="Marcar Pago Dictamen" arrow>
                        <Tooltip title="Marcar Pago Resolución" arrow>
                          <div className="d-flex flex-column align-items-center">
                            <div
                              className=" rounded-circle d-flex justify-content-center align-items-center "
                              style={{
                                width: "fit-content",
                                padding: "0.7rem",
                                cursor:
                                  acta?.dictamenes?.length > 0
                                    ? (acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante) || (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior)
                                      ? "not-allowed"
                                      : "pointer"
                                    : "pointer",
                                background:
                                  acta?.dictamenes?.length > 0
                                    ? (acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante) || (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior)
                                      ? "#c9c9c9"
                                      : "#C0FECB"
                                    : "#C0FECB",
                              }}
                              onClick={() => {
                                if (acta?.dictamenes?.length > 0) {
                                  if ((acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante) || (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior)) {
                                    <></>;
                                  } else {
                                    handlerModal({
                                      modal: true,
                                      modalName: "modal_pago_dictamen",
                                    });
                                  }
                                } else {
                                  handlerModal({ modal: true, modalName: "modal_pago_dictamen" });
                                }
                              }}
                            >
                              <PagoIcon
                                color={
                                  acta?.dictamenes?.length > 0
                                    ? (acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante) || (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior)
                                      ? "#777"
                                      : `#33893E`
                                    : `#33893E`
                                }
                              />
                            </div>
                            <p
                              className="m-0 fw-semibold d-flex justify-content-center text-center"
                              style={{
                                fontSize: "12px",
                                maxWidth: "50px",
                                color:
                                  acta?.dictamenes?.length > 0
                                    ? (acta?.dictamenes[0]?.fecha_pago && acta?.dictamenes[0]?.numero_comprobante) || (acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior)
                                      ? "#777"
                                      : `#33893E`
                                    : `#33893E`,
                              }}
                            >
                              {/* Marcar Pago Dictamen */}
                              Marcar Pago Resolución
                            </p>
                          </div>
                        </Tooltip>
                      }
                    </>
                  )}
                  {actions.hasRole("tribunales") && actions.hasPermission("dictamen.pagovoluntario.create") && acta.estado_id == 19 && (
                    <>
                      {acta?.dictamenes?.length > 0 && acta?.dictamenes[0]?.fecha_notificacion_anterior && acta?.dictamenes[0]?.fecha_vto_prejudicial_anterior && (
                        <Tooltip title="Consultar recibo" arrow>
                          <div className="d-flex flex-column align-items-center">
                            <div
                              className="bg-success-subtle  rounded-circle d-flex justify-content-center align-items-center "
                              style={{
                                width: "fit-content",
                                padding: "0.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handlerModal({ modal: true, modalName: "modal_recibo" });
                              }}
                            >
                              <ReciboIcon color="#198754" />
                            </div>
                            <p className="m-0 fw-semibold text-success d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                              Recibo
                            </p>
                          </div>
                        </Tooltip>
                      )}
                    </>
                  )}
                  {actions.hasPermission("JP") && acta.estado_id == 2 && (
                    <Tooltip title="Notificar acta" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-success-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_notificar_acta" });
                          }}
                        >
                          <HistoryFileIcon color="#198754" />
                        </div>
                        <p className="m-0 fw-semibold text-success d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Notificar
                        </p>
                      </div>
                    </Tooltip>
                  )}
                  {actions.hasPermission("acta.notificar_digital.update") && (acta.estado_id == 2 || acta.estado_id == 10) && acta?.domicilio_notificacion_id && (
                    <Tooltip title="Notificar acta digital" arrow>
                      <div className="d-flex flex-column align-items-center">
                        <div
                          className="bg-success-subtle  rounded-circle d-flex justify-content-center align-items-center "
                          style={{ width: "fit-content", padding: "0.7rem", cursor: "pointer" }}
                          onClick={() => {
                            handlerModal({ modal: true, modalName: "modal_notificar_digital" });
                          }}
                        >
                          <HistoryFileIcon color="#198754" />
                        </div>
                        <p className="m-0 fw-semibold text-success d-flex justify-content-center text-center" style={{ fontSize: "12px", maxWidth: "50px" }}>
                          Notificar digital
                        </p>
                      </div>
                    </Tooltip>
                  )}

                  {/* {console.log([2].includes(acta.estado_id) && (actions.hasRole("JP")))}
                                    {console.log(actions.hasPermission("JP"))} */}

                  {/* {
                                acta?.actas_hermanas?.length > 0 &&
                                <section className=" px-4 d-flex align-items-center gap-3 ">
                                    <div className=" d-flex flex-column gap-0  p-2 rounded border border-1 border-secondary position-relative ">
                                        <span className="m-0 text-danger fw-bold position-absolute" style={{ top: "-5px", backgroundColor: "#fff", lineHeight: "10px", fontSize: "12px" }}>Actas duplicadas</span>
                                        <div className="d-flex  gap-5">
                                            {acta?.actas_hermanas.map((actaH, index) => {
                                                return <div key={index}>
                                                    <Tooltip arrow title={`${actaH.estado.id == 3 ? "Cargar acta" : "Copiar número acta"}`}>
                                                        <div key={index} className="d-flex flex-column align-items-center justify-content-center" style={{ cursor: "pointer" }} onClick={() => {
                                                            if (actaH.estado.id == 3) {
                                                                handlerModal({ modal: false, modalName: "acta_detalle" });
                                                                getActaChequear(actaH.id)
                                                            } else {
                                                                copiarPortaPapeles(actaH.numero_acta)
                                                            }
                                                        }}>

                                                            <h6 className="m-0" style={{ fontSize: "12px" }}>{`Acta ${actaH?.dependencia} - ${actaH?.numero_acta}`}</h6>
                                                            <BadgeEstados estado_id={actaH.estado_id} size={'xxsm'} />
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            }
                                            )}
                                        </div>
                                    </div>
                                </section>
                            } */}
                </div>
              </>
            )}
            <div className="col d-flex flex-column  gap-2 ">
              {opciones?.map((opcion, index) => {
                return (
                  <div key={index}>
                    <Opcion icono={opcion.icono} label={opcion.label} modal={opcion.modal} type={"horizontal"} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default InfoActa2;
